import { render, staticRenderFns } from "./previewCard2.vue?vue&type=template&id=4a112ae8&scoped=true"
import script from "./previewCard2.vue?vue&type=script&lang=js"
export * from "./previewCard2.vue?vue&type=script&lang=js"
import style0 from "./previewCard2.vue?vue&type=style&index=0&id=4a112ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a112ae8",
  null
  
)

export default component.exports